document.addEventListener('DOMContentLoaded', function() {

    //swiper initialization
    let swiperInstance = null;
    
    function initSwiper() {
      const shouldUseSwiper = window.innerWidth < 1280;
      
      if (shouldUseSwiper && !swiperInstance) {
        // Initialize Swiper below 1280px
        swiperInstance = new Swiper('.featured-collection-swiper-mobile', {
          slidesPerView: 1.1,
          spaceBetween: 16,
          centeredSlides: false,
          breakpoints: {
            640: {
              slidesPerView: 1.5,
              spaceBetween: 16,
            },
            769: {
              slidesPerView: 2.2,
              spaceBetween: 16,
            },
            1024: {
              slidesPerView: 3.2,
              spaceBetween: 18,
            }
          }
        });
      } else if (!shouldUseSwiper && swiperInstance) {
        // Destroy Swiper on large desktop (≥1280px)
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }
    
    // Initialize on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSwiper);
    } else {
      initSwiper();
    }
    
    // Re-initialize on resize (debounced)
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initSwiper, 250);
    });
  
  /* Product ATC + Rebuy functionality */
  
    const FORM_SELECTOR = '.product-card__form';

    const openRebuyCart = () => {
      try {
        if (window.Rebuy?.SmartCart?.show) {
          window.Rebuy.SmartCart.show();
          window.Rebuy?.SmartCart?.reload?.();
          return true;
        }
        if (window.Rebuy?.Cart?.show) {
          window.Rebuy.Cart.show();
          window.Rebuy?.Cart?.reload?.();
          return true;
        }
        window.dispatchEvent(new CustomEvent('rebuy:cart.show'));
        window.dispatchEvent(new CustomEvent('rebuy:cart.reload'));
        const trigger =
                document.querySelector('[data-rebuy-open]') ||
                document.querySelector('.rebuy-cart__toggle') ||
                document.querySelector('[data-open-smartcart]');
        if (trigger) { trigger.click(); return true; }
      } catch (e) {
        console.warn('[featured-collection] Rebuy open failed:', e);
      }
      return false;
    };

    const directCheckoutRedirect = (form) => {
      const section = form.closest('[data-direct-checkout="true"]');
      if (!section) return false;

      const variantId = form.querySelector('input[name="id"]')?.value;
      if (!variantId) return false;

      const quantity = form.querySelector('input[name="quantity"]')?.value || '1';
      let checkoutUrl = '/checkout?updates[' + variantId + ']=' + quantity;
      const discountCode = section.dataset.discountCode;

      if (discountCode) {
        checkoutUrl += '&discount=' + encodeURIComponent(discountCode);
      }

      window.location.href = checkoutUrl;
      return true;
    };

    const ajaxAdd = async (form, btn) => {
      if (directCheckoutRedirect(form)) return;

      const fd = new FormData(form);
      if (!fd.get('quantity')) fd.set('quantity', '1');
      btn?.classList?.add('is-loading');
      btn?.setAttribute('aria-busy', 'true');
      btn?.setAttribute('disabled', 'true');

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: fd
        });

        if (!res.ok) {
          let msg = 'Unable to add to cart.';
          try { const err = await res.json(); msg = err?.description || err?.message || msg; } catch {}
          console.warn('[featured-collection] Add failed:', msg);
          alert(msg);
          return;
        }

        try {
          const item = await res.json();
          document.dispatchEvent(new CustomEvent('ajax:add-to-cart', { detail: item }));
          window.dataLayer?.push({ event: 'add_to_cart', ecommerce: { items: [{ item_id: String(item?.id||''), item_name: item?.title||'', quantity: Number(item?.quantity||1), price: item?.price ? item.price/100 : undefined }] }});
        } catch {}

        if (!openRebuyCart()) window.location.href = '/cart';
      } catch (e) {
        console.error('[featured-collection] Network error:', e);
        alert('We couldn’t add this item. Please try again.');
      } finally {
        btn?.classList?.remove('is-loading');
        btn?.removeAttribute('aria-busy');
        btn?.removeAttribute('disabled');
      }
    };

    const intercept = (target) => {
      const form = target.closest?.(FORM_SELECTOR);
      if (!form) return false;
      const btn = form.querySelector('button[type="submit"], .btn');
      
      try { event?.preventDefault?.(); } catch {}
      try { event?.stopPropagation?.(); } catch {}
      try { event?.stopImmediatePropagation?.(); } catch {}

      ajaxAdd(form, btn);
      return true;
    };

    window.addEventListener('submit', (e) => {
      if (e.target?.matches?.(FORM_SELECTOR)) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation?.();
        ajaxAdd(e.target, e.target.querySelector('button[type="submit"], .btn'));
      }
    }, true);

    window.addEventListener('click', (e) => {
      const el = e.target;
      if (!el) return;
      const btn = el.closest?.(`${FORM_SELECTOR} button[type="submit"], ${FORM_SELECTOR} .btn`);
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation?.();
        intercept(btn);
      }
    }, true);

    const seen = new WeakSet();
    const wireForm = (form) => {
      if (seen.has(form)) return;
      form.setAttribute('data-ajaxified', 'true');
      form.setAttribute('novalidate', 'novalidate');
      seen.add(form);
    };

    const scan = () => document.querySelectorAll(FORM_SELECTOR).forEach(wireForm);
    scan();

    const mo = new MutationObserver(() => scan());
    mo.observe(document.documentElement, { subtree: true, childList: true });

    window.addEventListener('pageshow', scan);
    document.addEventListener('shopify:section:load', scan);
    document.addEventListener('shopify:section:reorder', scan);
});